import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class PaymentRequestRoute extends Route {
  @service session;

  breadCrumb = {
    title: 'Richiesta pagamento',
  };

  model(params) {
    return params;
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    controller.initPageTask.perform();
  }

  resetController(controller) {
    controller.initPageTask.cancelAll();
  }
}
